/** PURE_IMPORTS_START tslib PURE_IMPORTS_END */
import * as tslib_1 from "tslib";
var ObjectUnsubscribedError = /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var _this = _super.call(this, 'object unsubscribed') || this;
        _this.name = 'ObjectUnsubscribedError';
        Object.setPrototypeOf(_this, ObjectUnsubscribedError.prototype);
        return _this;
    }
    return ObjectUnsubscribedError;
}(Error));
export { ObjectUnsubscribedError };
//# sourceMappingURL=ObjectUnsubscribedError.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js
// module id = 473
// module chunks = 2